module.exports = __webpack_public_path__ + "img/Img14_212110_CcFd-3-55.6619b215.jpg";